import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import {
  EventQueryKeys,
  EventStationResponseItem,
  MutateStationPayload,
} from '../types';

export function useEventStations(eventId: string, enabled: boolean) {
  const queryClient = useQueryClient();

  const baseUrl = `/events/${eventId}/stations`;

  const stationsQuery = useApiQuery<EventStationResponseItem[]>(`${baseUrl}`, {
    queryKey: [EventQueryKeys.Stations, String(eventId)],
    initialData: [],
    enabled: !!eventId && enabled,
  });

  const onSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: [EventQueryKeys.Stations, String(eventId)],
    });
  };

  const onError = (error: Error) => {
    toast.error(error.message);
  };

  const saveStationsMutation = useApiMutation<{
    stations: Omit<MutateStationPayload, 'id'>;
  }>(
    baseUrl,
    {
      method: 'POST',
    },
    {
      onError,
      onSuccess,
    }
  );

  return {
    stationsQuery,
    saveStationsMutation,
  };
}
